export const INSERT_CODE = 'insertCode';
export const BORDER_BACKGROUND = 'borderBackground';
export const INSERT_IMAGE = 'insertImage';
export const INSERT_SYMBOL = 'insertSymbol';
export const FORMAT = 'format';
export const DATE_TIME = 'dateTime';
